import React, { Component, Fragment } from 'react';
import Joyride from 'react-joyride';
import styled from 'styled-components';
import tourDef from './TourDef';
import authService from '../services/AuthService';

import './Tour.css';

const TooltipBody = styled.div`
  background-color: black;
  min-width: 290px;
  max-width: 420px;
  padding-bottom: 2rem;
`;

const TooltipContent = styled.div`
  color: #fff;
  padding: 20px;
`;

const TooltipTitle = styled.h2`
  color: #fff;
  padding: 20px;
  margin: 0;
`;

const TooltipFooter = styled.div`
  background-color: #3884c6;
  display: flex;
  padding: 4px 8px 4px 4px;
  justify-content: flex-end;
  margin-top: 1rem;

  * + * {
    margin-left: 0.5rem;
  }
`;

const Button = styled.button`
  background-color: transparent;
  color: #fff;
  border: 0px;
  font-size: smaller;
width: 80px;
`;

const SkipArea = styled.div`
align: left;
width: 100%;
`
const SkipButton = styled(Button)`
color: #F87A34;
width: 100px;
`;


const Tooltip = ({
    continuous,
    index,
    step,
    backProps,
    closeProps,
    skipProps,
    primaryProps,
    tooltipProps,
}) => (
        <TooltipBody {...tooltipProps}>
            {step.title && <TooltipTitle>{step.title}</TooltipTitle>}
            <TooltipContent>{step.content}</TooltipContent>
            <TooltipFooter>
                <SkipArea>
                <SkipButton {...skipProps}>
                    <span id="skip">Skip the Tour</span>
                    </SkipButton>
                    </SkipArea>
                {index > 0 && (
                    <Button {...backProps}>
                        <span id="back">Back</span>
                    </Button>
                )}
                {continuous && (
                    <Button {...primaryProps}>
                        <span id="next">Got it!</span>
                    </Button>
                )}
                {!continuous && (
                    <Button {...closeProps}>
                        <span id="close">Close</span>
                    </Button>
                )}
            </TooltipFooter>
        </TooltipBody>
    );

class Tour extends Component {

    constructor(props) {
        super(props);

        this.state = {
            name: props.name,
            run: tourDef.getRunTours()
        }

        this.tours = tourDef.getTours();
    }

    render() {
        let tour = this.tours.get(this.state.name);
        let steps = null;
        if (tour == null || authService.isRaterOrCaregiver) {
            return (<span></span>);
        }
        steps = tour.steps;
        return (
            <Joyride
                key={new Date()}
                steps={steps}
                run={this.state.run}
                showProgress
                showSkipButton
                continuous
                tooltipComponent={Tooltip}
                locale={{ skip: "Skip Tour", last: "Done", open: "Click for a product tour! (turn off in your profile)" }}
                styles={{
                    options: { textColor: '#4782C1', backgroundColor: '#FFF', primaryColor: '#F79421' },
                    tooltipContainer: { textAlign: 'left', backgroundColor: '#FFF' },
                    tooltipTitle: { fontSize: '24px' },
                    tooltip: { width: '500px', fontSize: '16px' },
                    buttonNext: { backgroundColor: '#E0FFFF', color: 'black', fontSize: '14px' },
                    buttonBack: { backgroundColor: 'transparent', color: 'black', fontSize: '14px' }
                }}
            />
        )
    }
}

export default Tour;


// WEBPACK FOOTER //
// ./src/productTour/Tour.js